/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import styles from '../../Components/status.module.scss';

const ADPStageStatus = ({ current_stage, userData, translation, scheduleEnable, calendarVisibility, isPaymentAvailable }) => {
  const [values, setValues] = useState([]);
  const statusDisable = (userData?.permit?.status===8 && userData?.suspended_details?.training_status==='Pending');
  const handleStage = (id) => {
    let stages = [{ id: 1, title: `${translation.traning}`, isCompleted: false, isActive: false },
      { id: 2, title: userData.permit_management_nomenclature?.adp_quiz || translation.quiz, isCompleted: false, isActive: false },
      { id: 3, title: translation.certificate, isCompleted: false, isActive: false }];
    if (!statusDisable) {
      stages.push({ id: 4, title: translation.application, isCompleted: false, isActive: false });
    }
    if (!statusDisable && (((scheduleEnable && calendarVisibility) || !scheduleEnable) || (current_stage==='payment')) && isPaymentAvailable) {
      stages.push({ id: 5, title: 'Payment' || translation.appointment, isCompleted: false, isActive: false });
    }
    if (!statusDisable && ((scheduleEnable && calendarVisibility) || current_stage==='scheduling')) {
      stages.push({ id: !isPaymentAvailable ? stages?.length + 1 : 6, title: userData.permit_management_nomenclature?.schedule || translation.appointment, isCompleted: false, isActive: false });
    }
    const update_values = stages;
    update_values.forEach((val) => {
      if (val.id <= id) {
        if (val.id === id) {
          val.isActive = true;
        } else {
          val.isCompleted = true;
        }
      }
      if (id === 7) {
        val.isCompleted = true;
      }
    });
    setValues(update_values);
  };

  useEffect(() => {
    const handleCurrentStage = (val) => {
      if (val !== undefined) {
        switch (val) {
          case 'training':
            handleStage(1);
            break;
          case 'quiz':
            handleStage(2);
            break;
          case 'certificate':
            handleStage(3);
            break;
          case 'application':
            handleStage(4);
            break;
          case 'payment':
            handleStage(5);
            break;
          case 'scheduling':
            handleStage(6);
            break;
          case 'completed':
            handleStage(7);
            break;
          default:
            break;
        }
      }
    };
    handleCurrentStage(current_stage);
  }, [current_stage, scheduleEnable]);

  return (
    <div className={styles.body_container} style={{ paddingTop: '20px' }}>
      <div className={styles.card}>
        { values?.map(value => (
          <div className={`${styles.cardItem} 
            ${value.isActive === true ? styles.active: ''}
            ${value.isCompleted === true ? styles.completed: ''}`}
            style={{ alignItems: 'center' }}
          >
            <span className={styles.circle}>
              {value?.isCompleted
                ? <span className={styles.tick}>&#10003;</span>
                : <span className={styles.id_style}>{value.id}</span>
              }
            </span>
            <span className={styles.descp} style={{ fontSize: '17px' }}>{value.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ADPStageStatus;
